import { render, staticRenderFns } from "./CatalogCategoryTreeField.vue?vue&type=template&id=b34bd336&"
import script from "./CatalogCategoryTreeField.vue?vue&type=script&lang=js&"
export * from "./CatalogCategoryTreeField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports